// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../../uikit/atoms/Icon/IconV5.bs.js");
let FileInputLink = require("../../../../v5/common/attachments/FileInputLink.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function InitialUploadPrompt(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: "upload",
        size: 70
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "To attach files drag & drop here or"
          }),
          JsxRuntime.jsx(FileInputLink.make, {
            onChange: props.onAddAttachments,
            multiple: true,
            children: "select files from your computer"
          }),
          JsxRuntime.jsx("div", {
            children: "(JPEG, JPG, PNG, PDF only)",
            className: "text-sm mt-4 text-zinc-400"
          })
        ],
        className: "relative flex flex-col items-center text-lg"
      })
    ],
    className: "p-2.5 flex flex-col justify-center items-center text-zinc-500 h-[226px]"
  });
}

let make = InitialUploadPrompt;

exports.make = make;
/* IconV5 Not a pure module */
